import VSelect from 'vuetify/lib/components/VSelect/VSelect';

const SelectEditor = VSelect.extend({
  props: {
    itemText: { type: [String, Array, Function], default: 'name' },
    itemValue: { type: [String, Array, Function], default: 'code' }
  }
})

export default {
  install: function (Vue) {
    Vue.component('select-editor', SelectEditor)
  }
}